"use client";

import { createContext, useContext } from "react";

import type { MultipackQuantity } from "@/components/BundleProduct/utils/getMultipacksQuantities";

type ProductData = {
  dynamicGalleryUrls?: Record<string, string>;
  multipacksQuantities?: MultipackQuantity[];
  mandatoryPositiveConsent?: boolean;
};

const ProductDataContext = createContext<ProductData>({});

export function ProductDataProvider({
  children,
  dynamicGalleryUrls,
  multipacksQuantities,
  mandatoryPositiveConsent,
}: ProductData & { children: React.ReactNode }) {
  return (
    <ProductDataContext.Provider value={{ dynamicGalleryUrls, multipacksQuantities, mandatoryPositiveConsent }}>
      {children}
    </ProductDataContext.Provider>
  );
}

export function useProductData(): ProductData {
  return useContext(ProductDataContext);
}
